(() => {
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;

  function bindGallery(slides) {
    if (!slides || slides.dataset.chTouchReady === 'true') return;
    slides.dataset.chTouchReady = 'true';
    slides.style.touchAction = 'pan-y';

    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let deltaX = 0;
    let direction = null;
    let swiped = false;

    const step = () => {
      const first = slides.firstElementChild;
      if (!first) return slides.clientWidth;
      const styles = getComputedStyle(slides);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    slides.addEventListener('touchstart', (event) => {
      if (!mobile() || event.touches.length !== 1) return;
      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startScroll = slides.scrollLeft;
      deltaX = 0;
      direction = null;
      swiped = false;
    }, { passive: true });

    slides.addEventListener('touchmove', (event) => {
      if (!mobile() || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;

      if (!direction && Math.max(Math.abs(dx), Math.abs(dy)) > 7) {
        direction = Math.abs(dx) > Math.abs(dy) * 1.05 ? 'horizontal' : 'vertical';
      }

      if (direction !== 'horizontal') return;
      event.preventDefault();
      deltaX = dx;
      swiped = true;
      slides.scrollLeft = startScroll - dx;
    }, { passive: false });

    const finish = () => {
      if (!mobile() || direction !== 'horizontal') {
        direction = null;
        deltaX = 0;
        return;
      }

      const distance = step();
      const threshold = Math.min(64, distance * 0.14);
      let target = startScroll;

      if (Math.abs(deltaX) > threshold) {
        target = startScroll + (deltaX < 0 ? distance : -distance);
      }

      const max = Math.max(0, slides.scrollWidth - slides.clientWidth);
      target = Math.max(0, Math.min(max, target));
      slides.scrollTo({ left: target, behavior: 'smooth' });

      window.setTimeout(() => {
        swiped = false;
      }, 350);

      direction = null;
      deltaX = 0;
    };

    slides.addEventListener('touchend', finish, { passive: true });
    slides.addEventListener('touchcancel', finish, { passive: true });

    slides.addEventListener('click', (event) => {
      if (!swiped) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function init() {
    document.querySelectorAll('media-gallery slideshow-slides').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();

(()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer=reduce?null:new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ch-in-view');observer.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
  function initMotion(root=document){root.querySelectorAll('#MainContent > .shopify-section:not(.hero-wrapper)').forEach(section=>{if(section.dataset.chMotionReady)return;section.dataset.chMotionReady='true';if(reduce){section.classList.add('ch-in-view');return;}section.classList.add('ch-reveal');observer.observe(section);});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initMotion(),{once:true});}else{initMotion();}
  document.addEventListener('shopify:section:load',()=>initMotion());
  })();

(() => {
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;

  function bindCollectionTouch(viewport) {
    if (!viewport || viewport.dataset.chCollectionTouchReady === 'true') return;
    viewport.dataset.chCollectionTouchReady = 'true';

    let card = null;
    let startX = 0;
    let startY = 0;
    let moved = false;
    let pressTimer = null;

    const clearPressTimer = () => {
      if (pressTimer !== null) window.clearTimeout(pressTimer);
      pressTimer = null;
    };

    const clearState = () => {
      clearPressTimer();
      card?.classList.remove('is-touching');
      card = null;
      moved = false;
    };

    viewport.addEventListener('touchstart', event => {
      if (!mobile() || event.touches.length !== 1) return;
      const targetCard = event.target.closest?.('.stc__card');
      if (!targetCard || !viewport.contains(targetCard)) return;

      clearState();
      const touch = event.touches[0];
      card = targetCard;
      startX = touch.clientX;
      startY = touch.clientY;
      moved = false;

      pressTimer = window.setTimeout(() => {
        if (!moved && card) card.classList.add('is-touching');
      }, 55);
    }, { passive: true });

    viewport.addEventListener('touchmove', event => {
      if (!card || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;

      if (Math.hypot(dx, dy) <= 8) return;
      moved = true;
      clearPressTimer();
      card.classList.remove('is-touching');
    }, { passive: true });

    viewport.addEventListener('touchend', () => {
      clearPressTimer();
      const activeCard = card;
      if (activeCard) {
        window.setTimeout(() => activeCard.classList.remove('is-touching'), 90);
      }
      card = null;
      moved = false;
    }, { passive: true });

    viewport.addEventListener('touchcancel', clearState, { passive: true });
  }

  function initCollectionTouch(root = document) {
    root.querySelectorAll?.('.stc__viewport').forEach(bindCollectionTouch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionTouch(), { once: true });
  } else {
    initCollectionTouch();
  }

  document.addEventListener('shopify:section:load', event => initCollectionTouch(event.target));
  new MutationObserver(() => initCollectionTouch()).observe(document.documentElement, { childList: true, subtree: true });
})();

/* CYCLING HUB — keep filter drawer closable after Shopify AJAX facet rerenders. */
(() => {
  const closeFilterDrawer = () => {
    const drawer = document.getElementById('filters-drawer');
    if (!drawer) return;

    if (typeof drawer.close === 'function') {
      drawer.close();
      return;
    }

    const panel = drawer.querySelector('dialog');
    drawer.removeAttribute('open');
    if (panel?.open) panel.close();
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const closeTrigger = target.closest(
      '#filters-drawer .theme-drawer__close-button, #filters-drawer .facets__see-results'
    );
    if (!closeTrigger) return;

    closeFilterDrawer();
  });
})();

/* CYCLING HUB — always open the filter drawer with every accordion collapsed. */
(() => {
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('.facets-toggle__button')) return;

    const drawer = document.getElementById('filters-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('details[open]').forEach(details => {
      details.open = false;
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }, true);
})();
